// 非同期版のsleep

export default ms => new Promise(resolve => setTimeout(resolve, ms))
